import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { MenuPlacement, MenuLayer, MenuItem } = jest.requireActual('bloko/blocks/drop/Menu/index.js');
export { MenuPlacement, MenuLayer, MenuItem };

export default mockComponentRenderProp('DropMenu', null, {
    withChildren: true,
});
